import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import moment from 'moment';
import 'moment/locale/fr';

export interface SlotSelection {
  id: number;
  start: moment.Moment;
  end: moment.Moment;
  teacher: any | null;
}

@Component({
  selector: 'app-ponctual-selection-list-fuse',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './ponctual-selection-list-fuse.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PonctualSelectionListFuseComponent {
  @Input() selections: SlotSelection[] = [];
  @Input() loading: boolean = false;

  @Output() removeSlot = new EventEmitter<number>();

  formatSlotDate(slot: SlotSelection): string {
    moment.locale('fr');
    return slot.start.format('dddd DD MMMM');
  }

  formatSlotTime(slot: SlotSelection): string {
    const start = slot.start.format('HH:mm');
    const end = slot.end.format('HH:mm');
    return `${start} - ${end}`;
  }

  onRemove(index: number): void {
    if (!this.loading) {
      this.removeSlot.emit(index);
    }
  }
}
